import React from 'react';
import PropTypes from 'prop-types';

class PlayerViewport extends React.Component {
  static propTypes = {
    inputRef: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
  };

  // Don't ever re-render this component
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { inputRef, id } = this.props;

    return <div ref={inputRef} id={id} />;
  }
}

export default PlayerViewport;
